import { Component } from '@angular/core';

import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { NgIf, NgClass } from '@angular/common';
import { UserConfigComponent } from './user-config/user-config.component';
import { NavComponent } from './nav/nav.component';

@Component({
    selector: 'header-template',
    templateUrl: './header-template.component.html',
    styleUrls: ['./header-template.component.scss'],
    imports: [NgIf, NgClass, UserConfigComponent, NavComponent]
})
export class HeaderTemplateComponent {

	constructor(public globals: Globals) {
		this.globals = globals;
	}

	validateEnvironment(): string {
		if (Globals.getEnvironment() !== "PROD") {
			return "dev_environment";
		} else {
			return "prod_environment";
		}
	}

}

